import React from 'react';
import { Handle, Position } from 'reactflow';
import Alert from '@mui/material/Alert';

function ThanosNode({ id, data }) {
    return (
        <>
            {data["parentNode"] === undefined &&
                <>
                    <Alert severity="warning">put me inside cluster :(</Alert>
                </>
            }
            <div style={{
                border: "1px black solid",
                padding: "1.2em 1.2em",
                display: 'flex'
            }}>
                <span> Thanos Server</span>
                {data["parentNode"] != undefined && <>
                    <Handle
                        className="sourceHandle"
                        position={Position.Left}
                        type="target"
                    />
                    <Handle
                        className="targetHandle"
                        position={Position.Right}
                        type="source"
                        style={{
                            left: 135
                        }}
                    />
                </>
                }


            </div>



        </>
    );
}

export default ThanosNode;